import { useState, useEffect, useMemo } from 'react';

function useIsDark() {
  const [isDark, setIsDark] = useState(
    () => window.matchMedia('(prefers-color-scheme: dark)').matches
  );
  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => setIsDark(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isDark;
}

export function useChartTheme() {
  const isDark = useIsDark();
  return useMemo(() => ({
    background: 'transparent',
    textColor: isDark ? '#cbd5e1' : '#334155',
    fontSize: 12,
    axis: {
      ticks: {
        line: { stroke: isDark ? '#334155' : '#cbd5e1' },
        text: { fill: isDark ? '#94a3b8' : '#475569' },
      },
      legend: {
        text: { fill: isDark ? '#94a3b8' : '#475569' },
      },
    },
    grid: {
      line: { stroke: isDark ? '#1e293b' : '#e2e8f0', strokeDasharray: '2 4' },
    },
    tooltip: {
      container: {
        background: isDark ? '#1e293b' : '#0f172a',
        color: '#e2e8f0',
        borderRadius: 8,
        padding: 12,
      },
    },
  }), [isDark]);
}
